import { memo } from "react";

import Box from "@mui/material/Box";
import { styled, Theme } from "@mui/material/styles";

import {
  getBaseInputContainerStyles,
  getBaseInputFocusedStyles,
  getBaseInputErrorStyles,
  getBaseInputInputStyles,
} from "@/dashboard-design-system/BaseInput";
import { INTERACTIVE_PSUEDO_CLASSES } from "@/dashboard-design-system/css";

const PREFIX = "EmailRecipientsInput";

export const classes = {
  input: `${PREFIX}-input`,
  chip: `${PREFIX}-chip`,
  error: `${PREFIX}-error`,
  clear: `${PREFIX}-clear`,
  chipContainer: `${PREFIX}-chipContainer`,
  rootWithClear: `${PREFIX}-rootWithClear`,
};

export const Root = memo(
  styled(Box)(({ theme }: { theme: Theme }) => ({
    padding: theme.spacing(1, 1, 0, 0),
    maxHeight: 94,
    overflowY: "auto",
    ...getBaseInputContainerStyles("neutral", theme),

    "&:focus, &:focus-visible, &:focus-within": {
      ...getBaseInputFocusedStyles(theme),
      [`& .${classes.clear}`]: {
        display: "flex",
      },
    },
    [`& .${classes.chipContainer}`]: {
      display: "flex",
      flexWrap: "wrap",
    },

    [`&&.${classes.error}`]: getBaseInputErrorStyles(theme),
    [`&& .${classes.input}`]: {
      ...getBaseInputInputStyles(theme),
      flex: 1,
      minWidth: 300,
      border: "none",
      paddingLeft: theme.spacing(1),
      marginBottom: theme.spacing(1),
      [INTERACTIVE_PSUEDO_CLASSES]: {
        outline: "none",
        border: "none",
      },
    },
    [`&& .${classes.chip}`]: {
      marginBottom: theme.spacing(1),
      marginLeft: theme.spacing(1),
      maxWidth: 220,
    },
    [`&.${classes.rootWithClear}`]: {
      paddingRight: theme.button.size.default.small + theme.legacySpacing(2),
    },
    [`& .${classes.clear}`]: {
      display: "none",
      position: "absolute",
      top: theme.spacing(0.5),
      right: theme.spacing(1.5),
    },
  }))
);
